import { commentsData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CommentsSection() {
  const ref = useScrollReveal();
  return (
    <section id="comments" ref={ref} className="reveal-section py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            读者评论
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            来自真实用户的使用反馈与评价
          </p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {item.author}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {item.date}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                "{item.content}"
              </p>
              <div className="flex items-center gap-1 mt-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}